import React from 'react';
import { useDrag } from 'react-dnd';
import { DragType } from '../DragBox';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    setDragBoxHide: React.Dispatch<React.SetStateAction<boolean>>;
    setDropBoxContent: React.Dispatch<React.SetStateAction<DragType>>;
    setDropBoxDropped: React.Dispatch<React.SetStateAction<boolean>>;
    dragItems?: any;
}

export const DroppedBox = ({
    setDragBoxHide,
    setDropBoxContent,
    setDropBoxDropped,
    dragItems,
    children,
    ...rest
}: Props) => {
    const [, drag] = useDrag(() => ({
        type: 'drag-box',
        item: {
            children,
            setHide: setDragBoxHide,
            items: dragItems,
            ...rest
        } as DragType,
        end: (draggedItem, monitor) => {
            const didDrop = monitor.didDrop();
            if (!didDrop) {
                setDragBoxHide(false);
            }
            setDropBoxContent({} as DragType);
            setDropBoxDropped(false);
        }
    }));

    return (
        <div ref={drag} {...rest}>
            {children}
        </div>
    );
};
